module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "application-container"
    }
  }, [_c('v-header'), _vm._v(" "), _c('main', {
    staticClass: "container"
  }, [_c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('router-view', {
    staticClass: "view-container"
  })], 1)], 1), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a386e85", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a386e85"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/layouts/main.vue
// module id = 389
// module chunks = 1